import React from "react";
import { Accordion } from "flowbite-react";
import "./Pdp.css";

const PdpAccordion = ({ product }) => {
  return (
    <Accordion className="pdp-accordion">

      <Accordion.Panel>
        <Accordion.Title className="accordion-title">
          Especificaciones
        </Accordion.Title>
        <Accordion.Content>

          {product.uso &&
            <p className="pdp-accordion-text">
              {"Uso: " + product.uso + "."}
            </p>
          }

          {product.lugardeuso &&
            <p className="pdp-accordion-text">
              {"Ambiente: " + product.lugardeuso + ", " + product.ambiente + "."}
            </p>
          }

          {product.caracteristicas ?
            <p className="pdp-accordion-text">{`Especificaciones: ${product.caracteristicas.map(item => ` ${item}`)}` + "."}</p>
            :
            null
          }

          {product.acabado &&
            <p className="pdp-accordion-text">
              {"Acabado: " + product.acabado + "."}
            </p>
          }

          {product.other &&
            <p className="pdp-accordion-text">
              {product.other}
            </p>
          }
          {product.quantity &&
            <p className="pdp-accordion-text">
              {"m²/caja: " + product.quantity + "."}
            </p>
          }
          {product.piece &&
            <p className="pdp-accordion-text">
              {"Pza/caja: " + product.piece + " pieza(s)" + "."}
            </p>
          }

          {product.color ?
            <p className="pdp-accordion-text">{`Color: ${product.color.map(item => ` ${item}`)}` + "."}</p>
            :
            null
          }


        </Accordion.Content>
      </Accordion.Panel>
    </Accordion>
  );
};

export default PdpAccordion;
